import { IconProp } from "@fortawesome/fontawesome-svg-core";
import { Control } from "react-hook-form";
import { UFDoraMultilineTextAutocomplete as UFDoraMultilineTextAutocompleteBase } from "dora-shared/frontend";
import { useAppDispatch, useSelector } from "../../redux-store";
import { deleteAutocompleteSuggestion } from "../../ducks/data/autocomplete-suggestions";
import {
  selectAutocompleteValues,
  selectInvoiceLineDescriptions,
} from "../../ducks/data/autocomplete-suggestions/selectors";
import { INVOICE_LINE_DESCRIPTION_KEY } from "dora-contracts";

type UFDoraMultilineTextAutocompleteProps = {
  name: string;
  control: Control<any>;
  autocompleteKey?: string;
  error?: boolean;
  disabled?: boolean;
  placeholder?: string;
  className?: string;
  id?: string;
  icon?: IconProp;
  "aria-label"?: string;
};

const UFDoraMultilineTextAutocomplete = ({
  name,
  control,
  autocompleteKey,
  ...rest
}: UFDoraMultilineTextAutocompleteProps) => {
  const dispatch = useAppDispatch();
  const resolvedKey = autocompleteKey ?? name;
  const options = useSelector(selectAutocompleteValues(resolvedKey));

  return (
    <UFDoraMultilineTextAutocompleteBase
      name={name}
      control={control}
      options={options}
      onDeleteOption={(value) =>
        dispatch(deleteAutocompleteSuggestion({ key: resolvedKey, value }))
      }
      {...rest}
    />
  );
};

// Invoice line descriptions are suggested per product, so the list follows the
// product currently selected on the line.
const UFInvoiceLineDescriptionAutocomplete = ({
  productId,
  ...rest
}: Omit<UFDoraMultilineTextAutocompleteProps, "autocompleteKey"> & {
  productId: string | null;
}) => {
  const dispatch = useAppDispatch();
  const options = useSelector(selectInvoiceLineDescriptions(productId));

  return (
    <UFDoraMultilineTextAutocompleteBase
      options={options}
      onDeleteOption={(value) =>
        dispatch(
          deleteAutocompleteSuggestion({
            key: INVOICE_LINE_DESCRIPTION_KEY,
            value,
            productId,
          })
        )
      }
      {...rest}
    />
  );
};

export { UFDoraMultilineTextAutocomplete, UFInvoiceLineDescriptionAutocomplete };
